var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftEnabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6461 17.8529L8.6466 12.8534C8.60011 12.807 8.56324 12.7518 8.53808 12.6911C8.51292 12.6304 8.49997 12.5654 8.49997 12.4997C8.49997 12.434 8.51292 12.3689 8.53808 12.3082C8.56324 12.2475 8.60011 12.1924 8.6466 12.146L13.6461 7.14651C13.7399 7.0527 13.8671 7 13.9998 7C14.1324 7 14.2597 7.0527 14.3535 7.14651C14.4473 7.24032 14.5 7.36756 14.5 7.50022C14.5 7.63289 14.4473 7.76013 14.3535 7.85394L9.70711 12.4997L14.3535 17.1454C14.3999 17.1919 14.4368 17.247 14.4619 17.3077C14.4871 17.3684 14.5 17.4335 14.5 17.4992C14.5 17.5648 14.4871 17.6299 14.4619 17.6906C14.4368 17.7513 14.3999 17.8064 14.3535 17.8529C14.307 17.8993 14.2519 17.9362 14.1912 17.9613C14.1305 17.9864 14.0655 17.9994 13.9998 17.9994C13.9341 17.9994 13.869 17.9864 13.8083 17.9613C13.7477 17.9362 13.6925 17.8993 13.6461 17.8529Z",
    fill: "#F9FAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftEnabled);
export default __webpack_public_path__ + "static/media/left-enabled.501ab01832afff4815954b7103b29185.svg";
export { ForwardRef as ReactComponent };